module.exports = __webpack_public_path__ + "media/images/product_lines/travel/main-ebd34deec0ef868ecfd6861d4cae153c.svg";